import { render, staticRenderFns } from "./RegattaList.vue?vue&type=template&id=140c3742&scoped=true&"
import script from "./RegattaList.vue?vue&type=script&lang=js&"
export * from "./RegattaList.vue?vue&type=script&lang=js&"
import style0 from "./RegattaList.vue?vue&type=style&index=0&id=140c3742&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140c3742",
  null
  
)

export default component.exports